import COLORS from '@/constants/colors';
import { Stack, Typography } from '@mui/material';

export function FormSectionTitle(props: { title: string; subtitle?: string }) {
  return (
    <Stack>
      <Typography
        sx={{ fontSize: '18px', fontWeight: 600, color: COLORS.gray_900 }}
      >
        {props.title}
      </Typography>
      {props.subtitle && (
        <Typography
          sx={{ fontSize: '14px', fontWeight: 400, color: COLORS.gray_600 }}
        >
          {props.subtitle}
        </Typography>
      )}
    </Stack>
  );
}
